const operators = {
    date: [
        { label: 'Is On', value: 'is_on' },
        { label: 'Is Before', value: 'is_before' },
        { label: 'Is On Or Before', value: 'is_on_or_before' },
        { label: 'Is After', value: 'is_after' },
        { label: 'Is On Or After', value: 'is_on_or_after' },
    ],
    description: [
        { label: 'Contains', value: 'contains' },
        { label: 'Does Not Contain', value: 'does_not_contain' },
        { label: 'Is', value: 'is' },
        { label: 'Is Not', value: 'is_not' },
        { label: 'Starts With', value: 'starts_with' },
        { label: 'Ends With', value: 'ends_with' },
        { label: 'Does Not Start With', value: 'does_not_start_with' },
        { label: 'Does Not End With', value: 'does_not_end_with' },
    ], 
    amount: [
        { label: 'Is Equal To', value: 'is_equal_to' },
        { label: 'Is Not Equal To', value: 'is_not_equal_to' },
        { label: 'Is Greater Than', value: 'is_greater_than' },
        { label: 'Is Greater Than Or Equal To', value: 'is_greater_than_or_equal_to' },
        { label: 'Is Less Than', value: 'is_less_than' },
        { label: 'Is Less Than Or Equal To', value: 'is_less_than_or_equal_to' },
        { label: 'Is Divisible By', value: 'is_divisible_by' },
        { label: 'Is Not Divisible By', value: 'is_not_divisible_by' },
    ]
}

const _evaluateDateCondition = (condition, fieldValue) => {
    if(condition?.value?.split('-').length !== 2) return false;
    if(!fieldValue || isNaN(new Date(fieldValue).getTime())) return false;

    const targetMonth = condition.value.split('-')[0];
    const targetDay = condition.value.split('-')[1]; 
    const txDate = new Date(fieldValue);
    const txMonth = txDate.getUTCMonth() + 1; 
    const txDay = txDate.getUTCDate(); 

    switch(condition.op) {
        case 'is_on':
            return (txMonth === parseInt(targetMonth) && txDay === parseInt(targetDay));
        case 'is_before':
            return (txMonth < parseInt(targetMonth) || (txMonth === parseInt(targetMonth) && txDay < parseInt(targetDay)));
        case 'is_on_or_before':
            return (txMonth < parseInt(targetMonth) || (txMonth === parseInt(targetMonth) && txDay <= parseInt(targetDay)));
        case 'is_after':
            return (txMonth > parseInt(targetMonth) || (txMonth === parseInt(targetMonth) && txDay > parseInt(targetDay)));
        case 'is_on_or_after':
            return (txMonth > parseInt(targetMonth) || (txMonth === parseInt(targetMonth) && txDay >= parseInt(targetDay)));
        default:
            return false;
    }
}

const _evaluateDescriptionCondition = (condition, fieldValue) => {
    const targetValue = condition.value.toLowerCase();
    const txValue = fieldValue.toLowerCase();
    if(!targetValue || !txValue) return false; 
    switch(condition.op) {
        case 'contains':
            return txValue.includes(targetValue);
        case 'does_not_contain':
            return !txValue.includes(targetValue);
        case 'is':
            return txValue === targetValue;
        case 'is_not':
            return txValue !== targetValue;
        case 'starts_with':
            return txValue.startsWith(targetValue);
        case 'ends_with':
            return txValue.endsWith(targetValue);
        case 'does_not_start_with':
            return !txValue.startsWith(targetValue);
        case 'does_not_end_with':
            return !txValue.endsWith(targetValue);
        default:
            return false;
    }
}

const _evaluateAmountCondition = (condition, fieldValue) => {
    const targetValue = parseFloat(condition.value);
    const txValue = parseFloat(fieldValue);
    switch(condition.op) {
        case 'is_equal_to':
            return txValue === targetValue;
        case 'is_not_equal_to':
            return txValue !== targetValue;
        case 'is_greater_than':
            return txValue > targetValue;
        case 'is_greater_than_or_equal_to':
            return txValue >= targetValue;
        case 'is_less_than':
            return txValue < targetValue;
        case 'is_less_than_or_equal_to':
            return txValue <= targetValue;
        case 'is_divisible_by':
            return (txValue % targetValue) === 0;
        case 'is_not_divisible_by':
            return (txValue % targetValue) !== 0;
        default:
            return false;
    }
}

const evaluateCondition = (condition, fieldValue) => {
    // Ensure we can evaluate...
    if(!condition || !condition.field || !condition.op || condition.value === undefined || condition.value === null)
        return false;  

    if(!fieldValue && fieldValue !== 0) return false; 
    
    switch(condition.field) {
        case 'date':
            return _evaluateDateCondition(condition, fieldValue);
        case 'description':
            return _evaluateDescriptionCondition(condition, fieldValue);
        case 'amount':
            return _evaluateAmountCondition(condition, fieldValue);
        default:
            return false;
    }
}

const rulePasses = (rule, transaction) => {
    if(!rule?.when?.length) return false; 
    if(rule.txType !== transaction.txType) return false;
    let allConditionsMet = true; 
    let anyConditionMet = false;
    for(const condition of rule.when) {
        const fieldValue = transaction[condition.field]; 
        const conditionMet = evaluateCondition(condition, fieldValue);
        if(!conditionMet)
            allConditionsMet = false;
        else
            anyConditionMet = true; 
    }

    if(rule.match === 'all')
        return allConditionsMet;

    return anyConditionMet; 
}

const classifySubType = (rules, transaction) => {
    for(const rule of rules){
        if(!rulePasses(rule, transaction)) 
            continue 

        const value = rule.then && rule.then.length > 0 ? rule.then[0].value : null

        return {
            rule: rule, 
            value: value, 
        };
    }
    return ; 
}

export { operators, evaluateCondition, rulePasses, classifySubType};